import { Patient } from "../types/patient";

export const formatPatientName = (patient: Patient): string => {
  const parts = [patient.firstName];
  if (patient.middleName) {
    parts.push(patient.middleName);
  }
  parts.push(patient.lastName);
  return parts.join(" ").trim() || "N/A";
};
